import client from '@/api/client';

export const ATTACHMENTS_TOKEN_START = 'attachments/token/START';
export const ATTACHMENTS_TOKEN_SUCCESS = 'attachments/token/SUCCESS';
export const ATTACHMENTS_TOKEN_FAILURE = 'attachments/token/FAILURE';

export const ATTACHMENTS_LIST_UPDATE = 'attachments/list/UPDATE';

export default {
  namespaced: true,
  state: {
    error: null,
    loading: true,
    result: {},
    list: [],
  },
  actions: {
    token({ commit }, payload) {
      commit(ATTACHMENTS_TOKEN_START);

      return new Promise((resolve, reject) => {
        client.post('/attachments/token', payload)
          .then((response) => {
            commit(ATTACHMENTS_TOKEN_SUCCESS, response);
            resolve(response);
          })
          .catch((error) => {
            commit(ATTACHMENTS_TOKEN_FAILURE, error);
            reject(error);
          });
      });
    },
    update({ commit }, payload) {
      return new Promise((resolve) => {
        commit(ATTACHMENTS_LIST_UPDATE, payload);

        resolve();
      });
    },
  },
  mutations: {
    [ATTACHMENTS_TOKEN_START](state) {
      state.error = null;
      state.loading = true;
      state.result = {};
      state.list = [];
    },
    [ATTACHMENTS_TOKEN_SUCCESS](state, response) {
      const result = response.data;

      state.error = null;
      state.loading = false;
      state.result = result;
      state.list = [];
    },
    [ATTACHMENTS_TOKEN_FAILURE](state, error) {
      let details = error;

      try {
        details = error.response.data.error;
      } catch (err) { /* */ }

      state.error = details;
      state.loading = false;
      state.result = {};
      state.list = [];
    },

    [ATTACHMENTS_LIST_UPDATE](state, response) {
      state.list = response.list || [];
    },
  },
};
